import React from "react";
import { ReactComponent as SettingsCircleFilledIcon } from '../../../../assets/icons/new/UI/SettingsCircleFilled.svg';
import PillActionButton from '../../../StocksLayout/PillActionButton';

interface IOpenStocksExportFormProps {
    toOpenStocksExportFormModal: () => void;
}

function OpenStocksExportForm({
    toOpenStocksExportFormModal
}: IOpenStocksExportFormProps) {

    function clickHandlers() {
        toOpenStocksExportFormModal();
    }

    return (
        <PillActionButton
            icon={SettingsCircleFilledIcon}
            label="Настройки"
            onClick={clickHandlers}
        />
    );
}

export default OpenStocksExportForm;
